import styled, { css } from 'styled-components';

export const Label = styled.label`
  text-transform: capitalize;
  color: var(--colorBlueGray600);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.24px;
  line-height: 16px;
  display: block;
  margin-bottom: 8px;
`;

export const FieldError = styled.div`
  color: var(--colorUIRedDark);
  font-size: 14px;
`;

export const FieldWrapper = styled.div<{ error?: boolean }>`
  margin-bottom: 14px;
  ${({ error }) =>
    error &&
    css`
      & > input {
        border-color: var(--colorUIRed);
      }
    `}
`;
